<template>
  <div id="app">
    <!-- banner:横向全屏-->
    <div class="banner">
      <!-- banner-in:固定宽高 居中 -->
      <div class="banner-in">
        <!-- banner-top:logo以及导航栏 -->
        <div class="banner-top">
          <router-link to="/index" class="logo clearfix">
            <img src="./assets/img/logo.png" alt="">
          </router-link>
          <div class="navbar fr">
            <router-link v-for="(item, i) in navbarList" :key="i" :to="item.link" class="navbar-link clearfix">
              <span class="link-bg"></span>
              <span class="link-title">{{item.title}}</span>
            </router-link>
          </div>
        </div>
        <!-- banner-title:大标题 -->
        <p class="banner-title">{{bannerTitle}}</p>
      </div>
    </div>
    <!-- 主要内容 -->
    <div class="content">
      <router-view/>
    </div>
    <!--版权-->
    <div class="copyRight">
      <p v-html="copyRightTitle"></p>
    </div>
    <!--下载-->
    <div class="download" v-show="false">
      <p class="downloadTip">下载客户端</p>
      <div class="code">
        <p>
          <img src="../static/img/yz_apk_download.png">
          <span>彩点助手·业主端</span>
        </p>
        <p>
          <img src="../static/img/cm_apk_download.png">
          <span>彩点助手·彩友端</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      bannerTitle: '专注提供全球体育赛事资讯和数据',
      copyRightTitle: 'Copyright © 2017-2020 武汉彩点科技 All Rights Reserved.   <br>鄂ICP备17028944号-3',
      navbarList: [
        {
          title: '首页',
          link: '/index'
        },
        // {
        //   title: '公司介绍',
        //   link: '/companyIntroduction'
        // },
        // {
        //   title: '产品介绍',
        //   link: '/productIntroduction'
        // },
        // {
        //   title: '帮助教程',
        //   link: '/helpTutorials'
        // },
        {
          title: '隐私政策',
          link: '/privacyPolicy'
        },
        {
          title: '联系我们',
          link: '/contactUs'
        }
      ]
    }
  },
  mounted () {
    this.showCode()
  },
  methods: {
    showCode () {
      let domDownload = document.getElementsByClassName('download')[0]
      let downloadTip = domDownload.getElementsByClassName('downloadTip')[0]
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        downloadTip.addEventListener('touchstart', () => {
          domDownload.classList.toggle('clickDownload')
        })
      } else {
        domDownload.addEventListener('mouseenter', () => {
          domDownload.classList.add('clickDownload')
        })
        domDownload.addEventListener('mouseleave', () => {
          domDownload.classList.remove('clickDownload')
        })
      }
    }
  }
}
</script>

<style lang="less">
  @import "assets/css/style";
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    width: 100%;
    min-width: 1200px;
    height: 100%;
    >.banner {
      width: 100%;
      height: 450px;
      background-color: #5C72BF;
      .banner-in {
        width: 1200px;
        height: 100%;
        margin: 0 auto;
        padding-top: 20px;
        .banner-top{
          width: 100%;
          height: 40px;
          .logo{
            float: left;
            img{
              display: block;
              height: 40px;
            }
          }
          .navbar{
            font-size: 14px;
            text-align: center;
            margin: 5px 0;
            .navbar-link{
              position: relative;
              float: left;
              width: 80px;
              height: 30px;
              margin: 0 5px;
              box-sizing: border-box;
              color: #fff;
              line-height: 30px;
              text-align: center;
              span{
                position: absolute;
                top: 0;
                left: 0;
                display: inline-block;
                width: 100%;
                height: 100%;
                &:first-child{
                  left: 50%;
                  transform: translateX(-50%);
                  width: 0;
                  transition: width .3s;
                  background-color: #fff;
                  border-radius: 5px;
                }
              }
              &:hover{
                span{
                  color: #5C72BF;
                  &:first-child{
                    width: 80px;
                  }
                }
              }
            }
            .router-link-active{
              span{
                color: #5C72BF;
                &:first-child{
                  width: 80px;
                }
              }
            }
          }
        }
        .banner-title{
          margin-top: 150px;
          font-size: 48px;
          color: #fff;
          text-align: center;
        }
      }
    }
    >.content{
      position: relative;
      top: -90px;
      width: 1200px;
      margin: 0 auto;
      background-color: #fff;
      box-shadow: 2px 2px 10px rgba(0, 0, 0, .5);
      min-height: 700px;
    }
    >.copyRight{
      width: 100%;
      height: 60px;
      background-color: #5c72bf;
      p{
        color: #fff;
        line-height: 30px;
        text-align: center;
      }
    }
    >.download{
      box-sizing: border-box;
      position: fixed;
      right: 30px;
      top: 50%;
      margin-top: -175px;
      width: 50px;
      height: 350px;
      background-color: rgba(0, 0, 0, .6);
      color: #fff;
      font-size: 20px;
      line-height: 40px;
      transition: width .5s;
      box-shadow: 2px 2px 10px rgba(0, 0, 0, .5);
      cursor: pointer;
      -webkit-animation-duration: 0.75s;
      animation-duration: 0.75s;
      -webkit-animation-name: bounceIn;
      animation-name: bounceIn;
      >p{
        box-sizing: border-box;
        text-align: center;
        float: right;
        width: 50px;
        padding: 75px 15px;
      }
      .code{
        position: relative;
        width: 0px;
        height: 100%;
        overflow: hidden;
        transition: width .5s;
        p{
          position: absolute;
          box-sizing: border-box;
          width: 300px;
          text-align: center;
          top: 50%;
          left: 0;
          transform: translateY(-50%);
          line-height: 50px;
          &:last-of-type{
            left: 300px;
          }
          img{
            width: 150px;
            display: block;
            margin: 0 auto;
          }
        }
      }
    }
    >.clickDownload{
      width: 650px;
      .code{
        width: 600px;
      }
    }
  }
  @keyframes bounceIn {
    from,
    20%,
    40%,
    60%,
    80%,
    to {
      -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    0% {
      opacity: 0;
      -webkit-transform: scale3d(0.3, 0.3, 0.3);
      transform: scale3d(0.3, 0.3, 0.3);
    }

    20% {
      -webkit-transform: scale3d(1.1, 1.1, 1.1);
      transform: scale3d(1.1, 1.1, 1.1);
    }

    40% {
      -webkit-transform: scale3d(0.9, 0.9, 0.9);
      transform: scale3d(0.9, 0.9, 0.9);
    }

    60% {
      opacity: 1;
      -webkit-transform: scale3d(1.03, 1.03, 1.03);
      transform: scale3d(1.03, 1.03, 1.03);
    }

    80% {
      -webkit-transform: scale3d(0.97, 0.97, 0.97);
      transform: scale3d(0.97, 0.97, 0.97);
    }

    to {
      opacity: 1;
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue